/**
 * 城市（省份）高尔夫球场着陆页配置
 * 同时被 src（Vite/Vue）与 server.js（SSR）引用，保持纯 JS 无框架依赖
 */
export const REGIONS = [
  {
    slug: 'guangdong',
    name: '广东',
    title: '广东高尔夫球场预订 - 价格查询与开球时间 - 星际高球联盟',
    keywords: '广东高尔夫,广州高尔夫,深圳高尔夫,东莞高尔夫,广东球场预订,珠三角高尔夫',
    description: '广东高尔夫球场资源全国领先，广州、深圳、东莞、珠海等地球场密集、交通便利，适合周末短途高尔夫出行。星际高球联盟提供广东各地球场实时价格与开球时间在线预订。',
    heading: '广东高尔夫球场预订',
    intro: [
      '广东是国内高尔夫球场密度最高、交通最便利的省份之一，广州、深圳、东莞、佛山、惠州、珠海等城市均分布着品质各异的球场，是华南地区球友最常选择的打球目的地。',
      '广州、深圳周边球场多紧邻市区，开车1小时内即可到达，适合工作日晚间或周末临时约球；东莞、惠州一带球场密度高、性价比突出，是本地球友的常规选择；珠海、中山则更偏休闲度假风格，适合搭配周边游一起安排。',
      '广东全年气候温暖，除盛夏正午高温时段外均适合下场，秋冬季节尤其舒适，是国内少数可全年打球的省份之一。',
    ],
  },
  {
    slug: 'hainan',
    name: '海南',
    title: '海南高尔夫球场预订 - 观澜湖/三亚球场价格查询 - 星际高球联盟',
    keywords: '海南高尔夫,海口高尔夫,三亚高尔夫,观澜湖高尔夫,海南球场预订,冬季高尔夫',
    description: '海南气候全年温暖，观澜湖、三亚鹿回头等球场品质顶尖，是国内冬季打球的首选目的地。星际高球联盟提供海南各地球场实时价格与开球时间在线预订，支持"1球1晚"套餐组合。',
    heading: '海南高尔夫球场预订',
    intro: [
      '海南是国内公认的高尔夫旅游首选目的地，气候全年温暖，即使北方寒冬时节也能下场挥杆，是冬季"避寒打球"最热门的省份。',
      '海口观澜湖高尔夫球会拥有10个球场，是亚洲最大的高尔夫球会之一；三亚鹿回头、香水湾等球场背靠海景，风光与球场品质兼具，适合安排2-4天的精品高尔夫度假行程。',
      '海南球场普遍支持"1球1晚"套餐预订，把果岭费、球童费与酒店住宿打包，比单独分开预订更划算，也是星际高球联盟在海南主推的预订方式。',
    ],
  },
  {
    slug: 'yunnan',
    name: '云南',
    title: '云南高尔夫球场预订 - 昆明/大理/丽江球场价格查询 - 星际高球联盟',
    keywords: '云南高尔夫,昆明高尔夫,大理高尔夫,丽江高尔夫,云南球场预订,高原高尔夫',
    description: '云南高尔夫球场多分布在昆明及大理、丽江等地，地处高原、夏季凉爽，是国内少数适合夏季打球的省份。星际高球联盟提供云南各地球场实时价格与开球时间在线预订。',
    heading: '云南高尔夫球场预订',
    intro: [
      '云南高尔夫球场多分布在昆明及周边，春城湖畔、滇池湖畔、云海谷等球场地处高原，夏季凉爽避暑，是国内少数适合夏季打球的省份之一。',
      '除了昆明，大理苍海高尔夫球会、丽江玉龙雪山高尔夫球会等球场紧邻雪山与古城，风景独特，适合把打球和旅行结合安排，保山腾冲、曲靖一带也各有特色球场可选。',
      '云南全年气候温和，四季皆可下场，冬季不冷、夏季不热，"春城"名号名副其实，很少受极端天气影响，是全年安排打球计划都比较稳妥的目的地。',
    ],
  },
  {
    slug: 'beijing',
    name: '北京',
    title: '北京高尔夫球场预订 - 顺义/朝阳球场价格查询 - 星际高球联盟',
    keywords: '北京高尔夫,顺义高尔夫,朝阳高尔夫,北京球场预订,北京高尔夫俱乐部',
    description: '北京是国内高尔夫球场数量最多的城市之一，顺义区最为集中，商务接待与团建需求旺盛。星际高球联盟提供北京各区球场实时价格与开球时间在线预订。',
    heading: '北京高尔夫球场预订',
    intro: [
      '北京是国内高尔夫球场数量最多的城市之一，尤其顺义区聚集了乡村高尔夫、金色河畔、东方太阳城等一批知名球会，是北京高尔夫的核心区域。',
      '朝阳、大兴、房山、丰台等区也各有代表性球场，多数距市区车程1小时内，适合工作日晚间或周末临时约球，商务接待与团建需求同样旺盛。',
      '北京球场季节性明显，4-10月是最佳打球季节，冬季部分球场会暂停营业，建议预订前先确认目标球场当季的开放时间。',
    ],
  },
  {
    slug: 'shanghai',
    name: '上海',
    title: '上海高尔夫球场预订 - 浦东/松江球场价格查询 - 星际高球联盟',
    keywords: '上海高尔夫,浦东高尔夫,松江高尔夫,上海球场预订,上海高尔夫俱乐部',
    description: '上海高尔夫球场多分布在松江、青浦、浦东等近郊区域，交通便利，赛事级球场与休闲球场兼有。星际高球联盟提供上海各区球场实时价格与开球时间在线预订。',
    heading: '上海高尔夫球场预订',
    intro: [
      '上海高尔夫球场以近郊为主，松江、青浦、崇明一带球场密集，天马、佘山、银涛等球会都是长三角球友熟悉的选择，多数车程1小时以内。',
      '浦东、奉贤、闵行等区也分布着旗忠、汤臣、华凯等特色球场，赛事级球场与休闲球场兼有，可按预算和打球需求灵活选择。',
      '上海气候四季分明，春秋两季最适合打球，梅雨季和盛夏高温时段球场人流相对较少，反而更容易约到理想的开球时间。',
    ],
  },
]
